module.exports = __webpack_public_path__ + "media/bootstrap-icons/align-end-27bc1f43.svg";